import React, { useRef } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/db';
import { useStore } from '../store/useStore';
import { useWheelNavigation } from '../hooks/useWheelNavigation';

export const SalaryComponentListView = ({ handleItemSelect, selectedIndex, setSelectedIndex }: any) => {
  const scrollRef = useRef(null);
  const activeCompany = useStore(state => state.activeCompany);
  
  const components = useLiveQuery(
    () => activeCompany ? db.salaryComponents.where('companyId').equals(activeCompany.id!).toArray() : []
  ) || [];

  const items = [{ name: 'Create', id: null }, ...components];

  useWheelNavigation(scrollRef, items.length, setSelectedIndex, false);

  return (
    <div className="flex flex-col w-full h-full bg-white z-20 absolute inset-0 font-sans text-[12px] text-black pb-4">
      <div className="bg-[#1e8585] text-white flex justify-between px-2 py-[2px] font-bold shadow-sm z-10">
        <span className="w-1/3 text-left">Salary Components</span>
        <span className="w-1/3 text-center">{activeCompany?.name}</span>
        <span className="w-1/3 text-right cursor-pointer hover:text-gray-300" onClick={() => handleItemSelect({ name: 'Quit' })}>✕</span>
      </div>

      <div className="bg-white text-black flex justify-between px-2 py-1 font-bold border-b border-[#aebec8] z-10 shadow-sm">
        <span>List of Components</span>
      </div>

      <div className="flex flex-col border-b border-[#aebec8] bg-white text-black font-bold px-2 py-1 shadow-sm">
        <div className="flex w-full">
          <div className="flex-1">Name</div>
          <div className="flex-1">Type</div>
          <div className="flex-1">Value Type</div>
        </div>
      </div>

      <div ref={scrollRef} className="flex-1 overflow-y-auto bg-white scrollbar-thin pb-6">
        {items.map((item: any, idx: number) => (
          <div 
            key={idx}
            className={`flex w-full px-2 py-[2px] cursor-pointer ${selectedIndex === idx ? 'bg-[#1e8585] text-white font-bold' : 'text-black hover:bg-gray-50'}`}
            onClick={() => handleItemSelect(item)}
          >
            {idx === 0 ? (
              <div className="flex-1 text-center font-bold text-[#1e8585]">{item.name} New Component</div>
            ) : (
              <>
                <div className="flex-1">{item.name}</div>
                <div className="flex-1">{item.type}</div>
                <div className="flex-1">{item.valueType} {item.valueType === 'Percentage' ? `(${item.percentageValue}%)` : ''}</div>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="flex border-t border-[#aebec8] bg-white h-[22px] w-full shadow-inner absolute bottom-0">
        <div className="flex-1 border-r border-[#aebec8] flex justify-between items-center px-1 cursor-pointer" onClick={() => handleItemSelect({ name: 'Quit' })}>
          <div className="flex items-center space-x-[2px] whitespace-nowrap">
            <span className="text-[#2a62a3] font-bold underline decoration-[#2a62a3] underline-offset-2">Q</span>
            <span className="text-[#2a62a3] font-bold">:</span><span className="text-black leading-none">Quit</span>
          </div>
        </div>
      </div>
    </div>
  );
};
